module.exports = new __parcel__URL__("Chess_tile_ql.f2411ff1.svg").toString();